import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'lib-cookie-policy',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './cookie-policy.component.html',
  styleUrl: './cookie-policy.component.scss',
})
export class CookiePolicyComponent implements OnInit {
  faChevronLeft = faChevronLeft;

  constructor(private location: Location) {}

  ngOnInit(): void {
    this.scrollToTop();
  }

  routerGoBack() {
    this.location.back()
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
